export enum Privileges {
  ALLOW_ALL = 1,
  TASK_REGISTRY = 2,
  OBJECT_REGISTRY = 3,
  SCHEDULE_EDITING = 7,
  OPEN_OF_DEV_ENVS = 9,
  TASK_FAVORITES = 10,
  SCHEDULE_REGISTRY = 11,
  SCHEDULER_LOGS = 12,
  USER_RIGHTS_ADM = 13,
  OBJECT_RUNNING = 14,
  OBJECT_DOWNLOAD = 15,
  OBJECT_SHOWING = 16,   /* обрабатывается в основном на сервере */
  OBJECT_OPENING = 17
}
